import { useCallback, useEffect, useState } from 'react';
import { trottleFunction } from '../utility/utility';
import { AuthService } from '../services/authService';

export function useActivityWatcher() {
  const [lastActivityDate, setLastActivityDate] = useState(new Date());

  const updateLastActivityDate = useCallback(trottleFunction(() => {
    setLastActivityDate(new Date());
  }, 30_000), []);

  const throttledRegisterActivity = useCallback(trottleFunction(() => {
    AuthService.registerActivity();
  }, 180_000), []);

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    const handleActivity = () => {
      updateLastActivityDate();
      throttledRegisterActivity();
    };

    events.forEach(event => window.addEventListener(event, handleActivity));

    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, []);

  return { lastActivityDate };
}
